import { render, staticRenderFns } from "./AppTemplateItem.vue?vue&type=template&id=0bdc03aa&scoped=true&"
import script from "./AppTemplateItem.vue?vue&type=script&lang=js&"
export * from "./AppTemplateItem.vue?vue&type=script&lang=js&"
import style0 from "./AppTemplateItem.vue?vue&type=style&index=0&id=0bdc03aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdc03aa",
  null
  
)

export default component.exports